import { render, staticRenderFns } from "./ResetFilters.vue?vue&type=template&id=2c1eb950&"
import script from "./ResetFilters.vue?vue&type=script&setup=true&lang=js&"
export * from "./ResetFilters.vue?vue&type=script&setup=true&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports